const countdownDisplay: HTMLElement = document.querySelector('#countdown-timer')
const countdownContainer: HTMLElement = document.querySelector('.timer-message')

const pad = (int: number): string => int.toString().padStart(2, '0')

const pluralize = (int: number): ''|'s' => (int === 1 ? '' : 's')

if (countdownDisplay) {
  const deadlineValue = countdownDisplay.dataset.deadline
  const deadline = new Date(deadlineValue)

  const callback = (): void => {
    const now = new Date()
    let diff = deadline.valueOf() - now.valueOf()
    if (diff > 0) {
      const hours = Math.floor(diff / 3600000)
      diff %= 3600000
      const mins = Math.floor(diff / 60000)
      diff %= 60000
      const secs = Math.floor(diff / 1000)
      const hoursText = `${hours} hr${pluralize(hours)} `
      const minsText = `${pad(mins)} min${pluralize(mins)} `
      const secondsText = `${pad(secs)} sec${pluralize(secs)}`
      const text = `${hours ? hoursText : ''}${mins ? minsText : ''}${secondsText}`
      countdownDisplay.innerText = text
    } else {
      clearInterval(intervalID)
      countdownContainer.parentNode?.removeChild(countdownContainer)
    }
  }
  const intervalID = window.setInterval(callback, 1000) // runs every second
  callback()
}
